import { render, staticRenderFns } from "./facets.vue?vue&type=template&id=0b33ecf7&scoped=true&lang=pug&"
import script from "./facets.vue?vue&type=script&lang=js&"
export * from "./facets.vue?vue&type=script&lang=js&"
import style0 from "./facets.vue?vue&type=style&index=0&id=0b33ecf7&scoped=true&lang=scss&"
import style1 from "./facets.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b33ecf7",
  null
  
)

export default component.exports